import { render } from "./otherInformation.vue?vue&type=template&id=1d3d88be&scoped=true"
import script from "./otherInformation.vue?vue&type=script&lang=js"
export * from "./otherInformation.vue?vue&type=script&lang=js"

import "./otherInformation.vue?vue&type=style&index=0&id=1d3d88be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3d88be"]])

export default __exports__